const ITEMS = [
  "Free Doorstep Visit",
  "Instant Estimate Calculator",
  "1–3 Day Express Installation",
  "Blackout & Sheer Curtains",
  "Smart Motorized Tracks",
  "Downtown Dubai",
  "Palm Jumeirah",
  "Dubai Marina",
  "Business Bay",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden bg-reef border-y border-reef-dark/40 py-3.5 select-none"
    >
      <div className="marquee-track flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span
            key={i}
            className="font-mono text-[11px] tracking-[0.25em] uppercase text-sand-bg/90 flex items-center"
          >
            <span className="px-6">{item}</span>
            <span className="text-sand-bg/40">•</span>
          </span>
        ))}
      </div>
    </div>
  );
}
